export const UnitsView = {
	Certificate: 'Certificate',
	'Loading...': 'Loading...',
	'You can download your completion certificate.':
		'You can download your completion certificate.',
	'You cannot download your completion certificate.':
		'You cannot download your completion certificate.',
	'You failed': 'You did not pass',
	'Error getting the verification link': 'Error getting the verification link',
	'Approved details.':
		'To finish your course and get your certificate, click the "Finish your course" button.',
	'Unit list': 'Module list',
	'Finish your course': 'Finish your course',
	'Course of': 'Course of "{{course}}"',
	'Complete your course': 'Complete your course',
	'Closing course...': 'Closing your course...',
	'Download certificate': 'Download certificate',
	'Downloading...': 'Downloading...',
	'Not reach the grade needed':
		'You did not reach the grade needed to pass the course. You can contact our support team to review your situation.',
	'Remaining attempts title': 'You still have attempts available',
	'Remaining attempts intro':
		'You still have attempts left in the following quizzes. You can retake them to improve your score before finishing the course:',
	'Finish anyway': 'Finish anyway',
	'Go back': 'Go back',
	unlimited_attempts: 'unlimited attempts',
	'unlimited attempts': 'unlimited attempts',
	attempts_left_one: '{{count}} attempt left',
	attempts_left_other: '{{count}} attempts left',
	'attempts left_one': '{{count}} attempt left',
	'attempts left_other': '{{count}} attempts left',
};
